const CAP = {
  title: "Línea de tiempo de Bitcoin",
  sections: [
    {
      heading: "1990–1991 — Primer arquetipo de blockchain",
      text: [
        "Stuart Haber y W. Scott Stornetta crean el primer arquetipo informático de una cadena de bloques para sellar temporalmente (“timestamping”) documentos digitales.",
        "El objetivo era registrar documentos de forma que no pudieran ser alterados posteriormente sin dejar rastro."
      ]
    },
    {
      heading: "1997 — Hashcash",
      text: [
        "Adam Back desarrolla Hashcash para combatir el correo spam.",
        "Hashcash utiliza un mecanismo de Prueba de Trabajo (Proof of Work), que más adelante serviría de base para el modelo de minería de Bitcoin."
      ]
    },
    {
      heading: "1998 — b-money",
      text: [
        "Wei Dai propone b-money, un sistema de efectivo electrónico descentralizado.",
        "Esta solución describe cómo realizar pagos electrónicos sin depender de una autoridad central, inspirando directamente diseños posteriores como Bitcoin."
      ]
    },
    {
      heading: "2005 — Bit Gold",
      text: [
        "Nick Szabo define Bit Gold, un sistema de dinero digital escaso basado en el mercado.",
        "Bit Gold introduce ideas clave sobre cómo controlar la inflación y crear un activo digital difícil de falsificar, considerado uno de los antecesores conceptuales de Bitcoin."
      ]
    },
    {
      heading: "Septiembre de 2008 — Crisis financiera mundial",
      text: [
        "Estalla la crisis financiera global y se tambalea el sistema financiero tradicional en gran parte del planeta.",
        "En este contexto de desconfianza hacia bancos y gobiernos se vuelve especialmente relevante la idea de un dinero electrónico descentralizado."
      ]
    },
    {
      heading: "31 de octubre de 2008 — Whitepaper de Bitcoin",
      text: [
        "Satoshi Nakamoto publica el whitepaper “Bitcoin: A Peer-to-Peer Electronic Cash System” en la lista de correo de criptografía.",
        "Define Bitcoin como una criptomoneda capaz de prevenir el doble gasto en una red peer-to-peer, sin necesidad de bancos centrales ni terceros de confianza.",
        "Propone combinar Prueba de Trabajo, criptografía de clave pública y una cadena de bloques con marca de tiempo."
      ]
    },
    {
      heading: "3 de enero de 2009 — Bloque génesis de Bitcoin",
      text: [
        "Se mina el bloque génesis (bloque 0) de la blockchain de Bitcoin.",
        "Este bloque incluye un mensaje en el campo de datos que hace referencia a la crisis financiera, dejando clara la motivación del proyecto."
      ]
    },
    {
      heading: "9 de enero de 2009 — Versión 0.1 de Bitcoin",
      text: [
        "Se publica la versión 0.1.0 del software de Bitcoin.",
        "Según el propio Satoshi Nakamoto, se trata de una versión alfa completamente experimental."
      ]
    },
    {
      heading: "10 de enero de 2009 — Primeros early adopters",
      text: [
        "Hal Finney se convierte en el segundo miembro en unirse a la red de Bitcoin y comienza a minar bloques.",
        "Posteriormente, Wei Dai y Nick Szabo también se vinculan al proyecto y participan como mineros tempranos de la red."
      ]
    },
    {
      heading: "12 de diciembre de 2009 — Desaparición de Satoshi",
      text: [
        "En esta fecha se registra una de las últimas comunicaciones públicas de Satoshi Nakamoto.",
        "Después de este periodo, Satoshi se retira progresivamente y deja el proyecto en manos de la comunidad."
      ]
    },
    {
      heading: "22 de mayo de 2010 — Bitcoin Pizza Day",
      text: [
        "Laszlo Hanyecz paga 10.000 BTC por dos pizzas a otro usuario del foro Bitcointalk.",
        "El comprador de las pizzas usa su tarjeta de crédito para pagarlas en una pizzería y recibe los bitcoins a cambio.",
        "Se considera la primera transacción documentada en la que se intercambia bitcoin por un bien del mundo real."
      ]
    },
    {
      heading: "Febrero de 2011 — Paridad con el dólar",
      text: [
        "Bitcoin alcanza por primera vez la paridad con el dólar estadounidense: 1 BTC = 1 USD.",
        "Este hito marca la entrada de Bitcoin en el radar de medios, curiosos e inversores a nivel global."
      ]
    },
    {
      heading: "4 de junio de 2011 — Se acepta Bitcoin como donación",
      text: [
        "Tras el bloqueo de los procesadores de pago Visa, Mastercard y PayPal, el sitio web Wikileaks comienza a aceptar donaciones en bitcoin.",
        "El caso muestra una de las fortalezas de Bitcoin: operar sin depender de intermediarios tradicionales."
      ]
    },
    {
      heading: "Septiembre de 2012 — Nace la Bitcoin Foundation",
      text: [
        "Se crea la Bitcoin Foundation, una organización sin ánimo de lucro fundada por Gavin Andresen, Jon Matonis, Patrick Murck, Charlie Shrem y Peter Vessenes.",
        "Su objetivo es acelerar el crecimiento global de Bitcoin mediante la estandarización, protección y promoción del protocolo de código abierto.",
        "La fundación también busca mantener a Bitcoin fiel a principios como la independencia de la política monetaria y la apertura del sistema."
      ]
    },
    {
      heading: "12 de marzo de 2013 — Primer fork importante",
      text: [
        "Se produce el primer fork relevante de la red Bitcoin debido a una incompatibilidad entre versiones del software.",
        "Este evento genera desacuerdos temporales entre mineros y pone de manifiesto la importancia de coordinar actualizaciones de clientes."
      ]
    },
    {
      heading: "Febrero de 2014 — Colapso de Mt.Gox",
      text: [
        "Mt.Gox, uno de los mayores exchanges de Bitcoin del mundo, suspende sus actividades alegando problemas técnicos.",
        "Más adelante se declara en bancarrota, dejando una deuda de más de 850.000 BTC a sus usuarios.",
        "El caso afecta gravemente la confianza en las casas de cambio centralizadas, aunque no compromete la seguridad del protocolo de Bitcoin en sí."
      ]
    },
    {
      heading: "Marzo de 2017 — BTC supera los 1.000 USD",
      text: [
        "La tasa de cambio de Bitcoin supera de nuevo la barrera de los 1.000 USD por unidad.",
        "A partir de este momento, Bitcoin entra en una etapa de fuerte crecimiento y atención mediática."
      ]
    },
    {
      heading: "1 de agosto de 2017 — Nace Bitcoin Cash",
      text: [
        "Se produce un hard fork en la blockchain de Bitcoin que da lugar a una nueva cadena: Bitcoin Cash (BCH).",
        "La división surge por desacuerdos sobre cómo escalar la red y aumentar la capacidad de transacciones.",
        "Posteriormente se activa un soft fork en Bitcoin para implementar SegWit (Segregated Witness), optimizando el espacio en los bloques."
      ]
    },
    {
      heading: "Noviembre de 2017 — BTC supera los 10.000 USD",
      text: [
        "El precio de mercado de Bitcoin supera por primera vez los 10.000 USD por unidad.",
        "En pocas semanas el precio se aproxima a los 20.000 USD, marcando uno de los ciclos alcistas más conocidos de la historia de Bitcoin."
      ]
    },
    {
      heading: "Febrero de 2021 — Impuestos pagados en BTC",
      text: [
        "El cantón suizo de Zug se convierte en uno de los primeros territorios europeos en aceptar bitcoin como medio de pago de impuestos.",
        "Este paso refuerza el uso de Bitcoin como medio de pago más allá del entorno puramente especulativo."
      ]
    },
    {
      heading: "8 de junio de 2021 – 1 de enero de 2022 — Moneda de curso legal",
      text: [
        "El 8 de junio de 2021, El Salvador aprueba una ley para adoptar Bitcoin como moneda de curso legal.",
        "La norma entra en vigor en septiembre de 2021, convirtiendo al país en el primero del mundo en dar a Bitcoin ese estatus oficial.",
        "A partir de entonces, Bitcoin puede utilizarse junto con la moneda fiduciaria local para pagos, precios y obligaciones en territorio salvadoreño."
      ]
    }
  ]
};

export default CAP;
